import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-progress-snackbar',
  templateUrl: './progress-snackbar.component.html',
  styleUrls: ['./progress-snackbar.component.scss'],
  standalone: false
})
export class ProgressSnackbarComponent {
  progress$: Observable<{ message: string; progress: number }>;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { 
      message: string; 
      progress: number; 
      progress$: Observable<{ message: string; progress: number }> 
    }
  ) {
    this.progress$ = data.progress$;
  }
}